import React from "react";

interface Props {}

const Header: React.FC<Props> = () => {
    return (
        <>
            <div id="dashboard-header" className="d-none"></div>
        </>
    );
};

export default Header;
